import { Vms } from '_lib/api';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { isVmsEnrolled, vmsDisplayName } from './pmvsTypes';
import { vmsAdapter } from './pmvsReducers';

const vmsStateDomain = (state: RootState) => state.pmvs;

export const vmsLoadingSelector = createSelector(vmsStateDomain, (pmvs) => pmvs.loading);

export const allVmsSelector = createSelector(vmsStateDomain, (pmvs) =>
  vmsAdapter
    .getSelectors()
    .selectAll(pmvs)
    .slice()
    .sort((a, b) => vmsDisplayName(a).localeCompare(vmsDisplayName(b))),
);

export const enrolledVmsSelector = createSelector(allVmsSelector, (vmsList) =>
  vmsList.filter(isVmsEnrolled),
);

/** @deprecated Use enrolledVmsSelector */
export const pmvsSelector = enrolledVmsSelector;

export const vmsByIdSelector = (id: string) =>
  createSelector(vmsStateDomain, (pmvs) => vmsAdapter.getSelectors().selectById(pmvs, id));

export const vmsIvimsByIdSelector = (vmsId: string) =>
  createSelector(vmsStateDomain, (pmvs) => pmvs.ivimsByVmsId[vmsId] ?? []);

export const vmsIvimsLoadingSelector = (vmsId: string) =>
  createSelector(vmsStateDomain, (pmvs) => pmvs.ivimsLoadingByVmsId[vmsId] ?? false);

export const vmsSelectOptionsSelector = createSelector(allVmsSelector, (vmsList) => vmsList);

export const vmsStatusAlertsSelector = createSelector(
  vmsStateDomain,
  (pmvs) => pmvs.statusAlerts,
);
